__turbopack_context__.v({
  "chevron": "FilterBar-module-scss-module__pUPNcG__chevron",
  "embedded": "FilterBar-module-scss-module__pUPNcG__embedded",
  "expanded": "FilterBar-module-scss-module__pUPNcG__expanded",
  "filterBar": "FilterBar-module-scss-module__pUPNcG__filterBar",
  "filters": "FilterBar-module-scss-module__pUPNcG__filters",
  "header": "FilterBar-module-scss-module__pUPNcG__header",
  "refAccordion": "FilterBar-module-scss-module__pUPNcG__refAccordion",
  "refAccordionContent": "FilterBar-module-scss-module__pUPNcG__refAccordionContent",
  "refAccordionHeader": "FilterBar-module-scss-module__pUPNcG__refAccordionHeader",
  "refAccordionName": "FilterBar-module-scss-module__pUPNcG__refAccordionName",
  "refNumberLabel": "FilterBar-module-scss-module__pUPNcG__refNumberLabel",
  "refNumberSection": "FilterBar-module-scss-module__pUPNcG__refNumberSection",
  "title": "FilterBar-module-scss-module__pUPNcG__title",
});
